<template>
    <div>
        <ScrollBar :minHeight="250" :maxHeight="250">
            <div v-for="error in errors" :key="error">
                <Alert type="danger">
                    <span> {{ error }}</span>
                </Alert>
            </div>
        </ScrollBar>
    </div>
</template>

<script>

import Alert from "@nixweb/nixloc-ui/src/component/layout/Alert";
import ScrollBar from "@nixweb/nixloc-ui/src/component/layout/ScrollBar.vue";

export default {
    name: "errors",
    props: ["errors"],
    components: {
        Alert,
        ScrollBar
    }
}


</script>
